import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation updateTaskSetMutation($input: UpdateTaskSetInput!) {
		updateTaskSet(input: $input) {
			taskSet {
				id
				name
				instanceName
				description
				estimateForecast
				billable
				instanceCount
				role {
					id
				}
				phase {
					id
				}
				statusColumn {
					id
				}
			}
			# How many existing instances the edit actually reached. Zero is a
			# success -- the set's defaults still changed -- so the confirmation
			# says the real number rather than implying every instance moved.
			instancesUpdated
			# The project, because this can rewrite many tasks at once. The caller
			# refetches from here rather than reconciling N rows by hand.
			project {
				id
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	// Which fields people actually edit on a set, and whether they narrow the
	// scope. That is what decides whether the forward-only split is pulling its
	// weight or just costing a dialog.
	tracking.trackEvent('Task Set Edited', {
		_Scoped: input.fromSequence != null,
	});
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
